<template>
  <div class="md:flex">
    <div class="mb-4 md:flex-1 md:mr-8 md:mb-0 md:max-w-1/2">
      <div class="font-sans-medium">{{ $t('You') }}</div>
      <BaseRadioButtons
        :items="options"
        :value="valueFor(amount)"
        @input="$emit('amount', $event.value)"
      >
        <BaseRadioButton
          slot-scope="slotProps"
          :active="amount === slotProps.item.value"
        >
          {{ slotProps.item.label }}
        </BaseRadioButton>
      </BaseRadioButtons>
    </div>
    <div
      v-if="needSpouseFinancial"
      :class="{
        'md:mr-8': !noHolding
      }"
      class="mb-4 md:flex-1 md:mb-0"
    >
      <div>{{ $t('Your spouse') }}</div>
      <BaseRadioButtons
        :items="options"
        :value="valueFor(spouseAmount)"
        @input="$emit('spouse', $event.value)"
      >
        <BaseRadioButton
          slot-scope="slotProps"
          :active="spouseAmount === slotProps.item.value"
        >
          {{ slotProps.item.label }}
        </BaseRadioButton>
      </BaseRadioButtons>
    </div>
    <div
      v-if="!noHolding"
      class="mb-4 md:flex-1 md:mb-0"
    >
      <div>{{ $t('Your holding') }}</div>
      <BaseRadioButtons
        v-if="!noHolding"
        :items="options"
        :value="valueFor(holdingAmount)"
        @input="$emit('holding', $event.value)"
      >
        <BaseRadioButton
          slot-scope="slotProps"
          :active="holdingAmount === slotProps.item.value"
        >
          {{ slotProps.item.label }}
        </BaseRadioButton>
      </BaseRadioButtons>
    </div>
  </div>
</template>

<script>
import { find, isNil } from 'lodash';
import BaseRadioButtons from '../../components/BaseRadioButtons.vue';
import BaseRadioButton from '../../components/BaseRadioButton.vue';
import kyc from '../../mixins/kyc';

export default {
  name: 'AmountSelects',
  components: {
    BaseRadioButtons,
    BaseRadioButton,
  },
  mixins: [kyc],
  props: {
    amount: {
      type: Number,
      default: null,
    },
    spouseAmount: {
      type: Number,
      default: null,
    },
    holdingAmount: {
      type: Number,
      default: null,
    },
    noHolding: {
      type: Boolean,
      default: false,
    },
    displaySalaryOptions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let options = [
      {
        label: 'Moins de 1 million€',
        value: 0,
      }, {
        label: '1 à 2 millions€',
        value: 1,
      }, {
        label: '2 à 4 millions€',
        value: 2,
      }, {
        label: '4 à 8 millions€',
        value: 4,
      }, {
        label: 'Plus de 8 millions€',
        value: 8,
      },
    ];
    const salaryOptions = [
      {
        label: 'Moins de 75 000€',
        value: 0,
      }, {
        label: '75 à 150 000€',
        value: 0.075,
      }, {
        label: 'Plus de 150 000€',
        value: 0.150,
      },
    ];
    if (this.displaySalaryOptions) {
      options = salaryOptions;
    }
    return { options };
  },
  methods: {
    valueFor(amount) {
      if (!isNil(amount)) {
        return find(this.options, { value: amount });
      }
      return this.options[0];
    },
  },
};
</script>
